var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoTextEditor',{attrs:{"textKey":"news","title":"Edit Client News","viewPermission":"IngameNewsView","editPermission":"IngameNewsEdit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }